import { createContext, ReactNode, useContext } from 'react'
import VisualPlan from 'app/frontend/types/custom/VisualPlan'

const emptyVisualPlans = new Map<number, VisualPlan>()

type LinkedVisualPlansValue = {
  visualPlansById: Map<number, VisualPlan>
  provided: boolean
}

const TeamEventLinkedVisualPlansContext = createContext<LinkedVisualPlansValue>(
  {
    visualPlansById: emptyVisualPlans,
    provided: false,
  },
)

type ProviderProps = {
  visualPlansById: Map<number, VisualPlan>
  children: ReactNode
}

export const TeamEventLinkedVisualPlansProvider = ({
  visualPlansById,
  children,
}: ProviderProps) => (
  <TeamEventLinkedVisualPlansContext.Provider
    value={{ visualPlansById, provided: true }}
  >
    {children}
  </TeamEventLinkedVisualPlansContext.Provider>
)

export const useEventLinkedVisualPlans = () =>
  useContext(TeamEventLinkedVisualPlansContext)
